import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import SVG from "../../../../components/SVG";
import { PLATFORMS } from "../platforms";
import Api from "../../../../api";

import PlatformsListHeader from "./PlatformsListHeader";

import postalCodesIMG from "../../../../assets/images/postal-codes.png";
import styles from "../push-modal.module.scss";
import llCoordsImg from "../../../../components/SVG/llCoords.png";

const PlatformsList = ({
  selectedPlatform,
  // isAuthorized,
  audience,
  handlePlatformSelect,
  onShow,
  country
}) => {
  const [
    smartClipdownloadCheckAbility,
    setSmartClipdownloadCheckAbility
  ] = useState(false);

  useEffect(() => {
    const checksmartClipIsDownload = async () => {
      await Api.platforms.smartClip
        .downloadCheckAbility()
        .then(res => {
          // eslint-disable-next-line camelcase
          if (res?.downloadAbility) {
            setSmartClipdownloadCheckAbility(true);
          } else {
            setSmartClipdownloadCheckAbility(false);
          }
        })
        .catch(error => {
          console.log(error);
        });
    };
    checksmartClipIsDownload();
  }, []);

  return (
    <>
      <div
        className={selectedPlatform ? styles.header_platform : styles.header}
      >
        {/* {selectedPlatform === PLATFORMS.adform && isAuthorized ? (
          <span>
            Provide line-item-id to
            <br />
            {`push ${audience ? audience?.name : ""} to Adform`}
          </span>
        ) : (
          <span style={{ textAlign: "center" }}>
            Which platform do you want to activate in?
          </span>
        )} */}
        <PlatformsListHeader
          selectedPlatform={selectedPlatform}
          audience={audience}
        />
      </div>
      <div
        className={`${styles["platforms-list"]} ${
          onShow && selectedPlatform ? styles["slide-to-left"] : ""
        }`}
      >
        <button
          type="button"
          className={`${styles.platform}`}
          onClick={() => {
            handlePlatformSelect(PLATFORMS.ttd);
          }}
        >
          <SVG.TheTradeDesk className={styles["platform-icon"]} />
          The Trade Desk
          <SVG.ArrowClient
            className={styles["platform-arrow"]}
            width={32}
            height={24}
          />
        </button>
        <button
          type="button"
          className={`${styles.platform}`}
          onClick={e => {
            e.preventDefault();
            handlePlatformSelect(PLATFORMS.facebook);
          }}
        >
          <SVG.FacebookPlatform className={styles["platform-icon"]} />
          Facebook
          <SVG.ArrowClient
            className={styles["platform-arrow"]}
            width={32}
            height={24}
          />
        </button>
        <button
          type="button"
          className={`${styles.platform} ${/* styles.disabled */ " "}`}
          onClick={() => {
            handlePlatformSelect(PLATFORMS.google);
          }}
        >
          <SVG.Google360 className={styles["platform-icon"]} width={40} />
          Display & Video 360
          <SVG.ArrowClient
            className={styles["platform-arrow"]}
            width={32}
            height={24}
          />
        </button>
        <button
          type="button"
          id="adform-button"
          className={`${styles.platform}`}
          onClick={() => {
            handlePlatformSelect(PLATFORMS.adform);
          }}
        >
          <SVG.AdForm className={styles["platform-icon"]} />
          Adform
          <SVG.ArrowClient
            className={styles["platform-arrow"]}
            width={32}
            height={24}
          />
        </button>

        {/* <button */}
        {/*  type="button" */}
        {/*  className={`${styles.platform}`} */}
        {/*  onClick={() => { */}
        {/*    handlePlatformSelect(PLATFORMS.googleAds); */}
        {/*  }} */}
        {/* > */}
        {/*  <SVG.GoogleAds className={styles["platform-icon"]} /> */}
        {/*  Google Ads */}
        {/*  <SVG.ArrowClient */}
        {/*    className={styles["platform-arrow"]} */}
        {/*    width={32} */}
        {/*    height={24} */}
        {/*  /> */}
        {/* </button> */}

        <button
          type="button"
          className={`${styles.platform}`}
          onClick={() => {
            handlePlatformSelect(PLATFORMS.snapchat);
          }}
        >
          <SVG.Snapchat className={styles["platform-icon"]} />
          Snapchat
          <SVG.ArrowClient
            className={styles["platform-arrow"]}
            width={32}
            height={24}
          />
        </button>
        <button
          type="button"
          id="llCoordinates-button"
          className={`${styles.platform}`}
          onClick={() => {
            handlePlatformSelect(PLATFORMS.postalCodes);
          }}
        >
          <img
            src={postalCodesIMG}
            width={40}
            className={styles["platform-icon"]}
            alt="PostalCodes"
          />{" "}
          Postal Codes
          <SVG.ArrowClient
            className={styles["platform-arrow"]}
            width={32}
            height={24}
          />
        </button>
        <button
          type="button"
          id="llCoordinates-button"
          className={`${styles.platform}`}
          onClick={() => {
            handlePlatformSelect(PLATFORMS.llCoordinates);
          }}
        >
          <img
            width={40}
            src={llCoordsImg}
            className={styles["platform-icon"]}
            alt=""
          />
          LL - Coordinates
          <SVG.ArrowClient
            className={styles["platform-arrow"]}
            width={32}
            height={24}
          />
        </button>
        {country !== "GB" && country !== "IT" ? (
          <button
            type="button"
            className={`${styles.platform}`}
            onClick={() => {
              handlePlatformSelect(PLATFORMS.xandr);
            }}
          >
            <img
              src={SVG.Xandr}
              className={styles["platform-icon"]}
              alt="xandr"
            />
            Xandr
            <SVG.ArrowClient
              className={styles["platform-arrow"]}
              width={32}
              height={24}
            />
          </button>
        ) : null}
        {smartClipdownloadCheckAbility && (
          <button
            type="button"
            className={`${styles.platform}`}
            onClick={() => {
              handlePlatformSelect(PLATFORMS.postalCodes);
            }}
          >
            <img
              src={postalCodesIMG}
              style={{ width: 40 }}
              className={styles["platform-icon"]}
              alt="SmartClip"
            />{" "}
            Postal Codes
            <SVG.ArrowClient
              className={styles["platform-arrow"]}
              width={32}
              height={24}
            />
          </button>
        )}
      </div>
    </>
  );
};

PlatformsList.propTypes = {
  selectedPlatform: PropTypes.string,
  // isAuthorized: PropTypes.bool,
  audience: PropTypes.shape({ name: PropTypes.string }),
  handlePlatformSelect: PropTypes.func,
  onShow: PropTypes.bool,
  country: PropTypes.string
};

PlatformsList.defaultProps = {
  selectedPlatform: "",
  // isAuthorized: false,
  audience: { name: "" },
  handlePlatformSelect: () => {},
  onShow: false,
  country: ""
};

export default PlatformsList;
